import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

/**
 * One-way channel from an artifact renderer (in the report panel) back to the
 * chat, so an interactive artifact can ask the agent to re-run with new inputs.
 *
 * The panel hosts renderers via NgComponentOutlet (inputs only — no output
 * binding), and renderers must not depend on the chat/WebSocket directly. A
 * root singleton — like ArtifactService — lets a renderer (e.g. the dashboard's
 * filter/drill-down/refresh) emit a follow-up message that AgentHomeChat
 * subscribes to and sends over the existing WebSocket as a normal turn.
 */
@Injectable({ providedIn: 'root' })
export class ArtifactActionService {
  private readonly _messages = new Subject<string>();

  /** Follow-up chat messages emitted by an artifact renderer. */
  readonly messages$: Observable<string> = this._messages.asObservable();

  /** Ask the chat to send `message` to the current agent (drill-down/refresh). */
  send(message: string): void {
    const text = (message || '').trim();
    if (text) this._messages.next(text);
  }
}
